<template>
    <div ref="clearMap" class="clear-map-button">
        <md-button title="Clear map" class="md-icon-button" @click="clearMap()"><md-icon>clear</md-icon></md-button>
    </div>
</template>

<script>
/*
 * ---------------------------------------------------------------------------
 * COMMERCIAL IN CONFIDENCE
 * 
 * (c) Copyright Quosient Ltd. All Rights Reserved.
 * 
 * See LICENSE.txt in the repository root.
 * ---------------------------------------------------------------------------
*/
import { AreaService } from "@/services/area.service";

export default {
    props: {
        google: {
            type: Object,
            required: true
        },
        map: {
            type: Object,
            required: true
        }
    },
    methods: {
        clearMap() {
            AreaService.clearMap();
        }
    },
    mounted() {
        // this positions the clear map button into the LHS map controls
        const clearMap = this.$refs.clearMap;
        this.map.controls[this.google.maps.ControlPosition.RIGHT_TOP].push(clearMap);
    }
}
</script>

<style lang="scss" scoped>
.clear-map-button {
    padding-left: 2px;
    margin: 6px 6px 0 0;

    .md-button {
        margin:0;
        background-color: #ffff;
        box-shadow: #0000004d 0px 1px 4px -1px;
    }
}

</style>